(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const currentUrl = new URL(window.location.href);
    const theme = currentUrl.searchParams.get("theme");

    // No theme parameter -> leave everything untouched
    if (!theme) return;

    document.querySelectorAll('a[href]').forEach((link) => {
      let href = link.getAttribute("href");

      if (!href) return;

      // Ignore external, mail, tel, anchors, javascript
      if (
        href.startsWith("http") ||
        href.startsWith("//") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        href.startsWith("#") ||
        href.startsWith("javascript:")
      ) {
        return;
      }

      // Only product links
      if (!href.startsWith("/products/")) return;

      const productUrl = new URL(href, window.location.origin);

      // Preserve/update theme parameter
      productUrl.searchParams.set("theme", theme);

      link.href = productUrl.pathname + productUrl.search + productUrl.hash;
    });
  });
})();